// extracted by mini-css-extract-plugin
export default {"filterContainer":"InternalInvestorEligibilityExclusionsDialog_filterContainer__UgSlj"};